import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {SpinnerPosition} from "../../../../../shared/spinner/spinner.component";
import {EventBusService, SpinnerLocation} from "../../../../../services/event-bus.service";
import {Subscription} from "rxjs";
import {Model} from "../../../../../services/api.service";
import {NewProject} from "../../../../../interfaces/app.interfaces";
import {AppStateService} from "../../../../../services/app.state.service";
import {SidebarSelectionService} from "../../../../../services/sidebar-selection.service";

@Component({
    selector: 'app-chat-main',
    templateUrl: './chat-main.component.html',
    styleUrls: ['./chat-main.component.scss']
})

export class ChatMainComponent implements OnInit, OnDestroy {

    protected readonly SpinnerPosition = SpinnerPosition;

    selectedModelSubscription!: Subscription;
    selectedDropdownModelSubscription!: Subscription;
    selectedProjectSubscription!: Subscription;

    selectedModel!: Model;
    selectedDropdownModel!: Model;
    selectedProject: NewProject | null = null;

    showSpinner: boolean = false;
    isLoadingSubscription!: Subscription;
    isFileOver = false;

    dragCounter = 0;

    constructor(
        private eventBus: EventBusService,
        private state: AppStateService,
        private selection: SidebarSelectionService,
        private cd: ChangeDetectorRef
    ) { }

    disableAddFileEvent(): boolean {
        if (this.selectedProject) {
            return !this.selectedDropdownModel.supportsVision;
        } else {
            return !this.selectedModel.supportsVision;
        }
    }

    onDragOver(event: DragEvent) {
        event.preventDefault();
    }

    onDragLeave(event: DragEvent) {
        event.preventDefault();
        this.dragCounter--;
        if (this.dragCounter === 0) {
            this.isFileOver = false;
        }
    }

    onDragEnter(event: DragEvent) {
        event.preventDefault();
        this.dragCounter++;
        if (this.dragCounter === 1) {
            this.isFileOver = true;
        }
    }

    onDrop(event: DragEvent) {
        event.preventDefault();
        this.dragCounter = 0;
        this.isFileOver = false;
        if (!this.disableAddFileEvent()) {
            const files = event.dataTransfer;
            this.eventBus.addDragAndDropAttachments.next(files);
        }
    }

    ngOnInit(): void {
        this.isLoadingSubscription = this.eventBus.isLoading.subscribe(loadingData => {
            if (loadingData && (loadingData.location === SpinnerLocation.Body)) {
                this.showSpinner = loadingData.isLoading;
                this.cd.detectChanges();
            }
        })
        this.selectedModelSubscription = this.state.selectedAIModel.subscribe(value => {
            if (value) {
                this.selectedModel = value;
            }
        });
        this.selectedDropdownModelSubscription = this.state.selectedDropdownModel.subscribe(value => {
            if (value) {
                this.selectedDropdownModel = value;
            }
        });
        this.selectedProjectSubscription = this.selection.observe().subscribe((state) => {
            if(state && state.project) {
                this.selectedModel = state.project.model;
                this.selectedProject = state.project;
            }
        });
    }

    ngOnDestroy(): void {
        this.selectedModelSubscription.unsubscribe();
        this.selectedDropdownModelSubscription.unsubscribe();
        this.selectedProjectSubscription.unsubscribe();
    }
}
